<template>
  <main class="dashboard">
    <MainLayout />
    <div class="main-section" style="min-height: 100vh; background: rgb(248, 249, 253)">
      <div class="container">
        <div class="is-flex">
          <h3 class="title is-2 has-text-centered pt-3 is-flex-grow-5">
            {{ basicData.company_name }} {{ this.companyRut }}
          </h3>
          <SimpleButton :buttonStyle="`linear-gradient(225deg, #eff9ff, #fafdff)`" @click="() => back()"
            class="volverButton is-flex-grow-0 simple_button_extra">
            <span style="font-size: 20px"><img :src="arrow" class="arrow" /> Volver</span>
          </SimpleButton>
        </div>

        <div class="is-relative plainCard has-text-centered is-clipped has-background-white">
          <p class="has-text-primary-dark is-uppercase has-text-weight-semibold" style="
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            " :title="basicData.nameContact">
            Empresa {{ basicData.company_type }}
          </p>
        </div>
        <div class="pane_container">
          <div class="left-pane">
            <SimpleButton :class="[
              'side_button',
              { activeButton: activeButton == 'basic' },
            ]" @click="() => showContent('basic')">
              Datos Basicos
            </SimpleButton>
            <SimpleButton :class="[
              'side_button',
              { activeButton: activeButton == 'businessType' },
            ]" @click="() => showContent('businessType')">
              Tipo de Negocio
            </SimpleButton>
            <SimpleButton :class="[
              'side_button',
              { activeButton: activeButton == 'accountPlan' },
            ]" @click="() => showContent('accountPlan')">
              Plan de Cuentas
            </SimpleButton>
            <SimpleButton :class="[
              'side_button',
              { activeButton: activeButton == 'categories' },
            ]" @click="() => showContent('categories')">
              Categorías
            </SimpleButton>
            <SimpleButton :class="['side_button', { activeButton: activeButton == 'subida_datos' }]"
              @click="() => showContent('subida_datos')">
              Subida de datos
            </SimpleButton>
          </div>
          <div class="right-pane p-2">
            <div v-if="activeButton === 'basic'" class="pane">
              <CompanyInfoBasicData :basicData="basicData" />
            </div>
            <div v-if="activeButton === 'businessType'" class="pane">
              <CompanyInfoBusinessType :basicData="basicData" />
            </div>
            <div v-if="activeButton === 'accountPlan'" class="pane">
              <CompanyInfoAccountPlan ref="accountPlan" :basicData="basicData" />
            </div>
            <div v-if="activeButton === 'categories'" class="pane">
              <CompanyInfoCategories :company_id="basicData.companyId" />
            </div>
            <div v-if="activeButton === 'subida_datos'" class="pane">
              <CompanyInfoDataEntry :fileData="fileData" :basicData="basicData">
              </CompanyInfoDataEntry>
            </div>
          </div>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
import { getDetalleCompania } from "@/api/carteraAnalista";
import MainLayout from "@/components/layout/MainLayout";
import SimpleButton from "@/components/modals/SimpleButton";
import CompanyInfoAccountPlan from "@/views/CompanyInfo_AccountPlan";
import CompanyInfoBasicData from "@/views/CompanyInfo_BasicData";
import CompanyInfoBusinessType from "@/views/CompanyInfo_BusinessType";
import CompanyInfoCategories from "@/views/CompanyInfo_Categories";
import CompanyInfoDataEntry from "@/views/CompanyInfo_DataEntry";

import { mapState } from "vuex";

export default {
  name: "CompanyInfo",
  components: {
    MainLayout,
    SimpleButton,
    CompanyInfoBasicData,
    CompanyInfoBusinessType,
    CompanyInfoCategories,
    CompanyInfoAccountPlan,
    CompanyInfoDataEntry,
  },
  created() {
    const companyId = this.$route.query.companyId;
    this.companyRut = this.$route.query.companyRut;
    if (!companyId) {
      this.$router.push({ name: "panel-analista" });
    } else {
      this.fetchCompanyData(companyId);
    }
  },
  mounted() {
    this.showContent("basic");
  },
  data() {
    return {
      activeButton: "",
      basicData: {},
      fileData: [],
      companyRut: "",
      loadingReloadDrive: false,
    };
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    publicPath() {
      const localhost = ["localhost", "0.0.0.0"];
      if (localhost.includes(window.location.hostname)) {
        return `http://${window.location.hostname}`;
      } else {
        return `https://${window.location.hostname}`;
      }
    },
    arrow() {
      return `${this.publicPath}/arrow-back-128.png`;
    },
  },
  methods: {
    async fetchCompanyData(id) {
      try {
        const resp = await getDetalleCompania(id, true);
        this.basicData = resp.data;
        this.basicData.companyId = parseInt(id);
        this.fileData = Object.values(this.basicData["file_data"]);
        this.fileData.sort((a, b) => a.order - b.order);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    },
    back() {
      this.$router.push({ name: "panel-analista" });
    },
    showContent(contentId) {
      this.activeButton = contentId;
    },
  },
};
</script>
<style scoped>
.archivo_button {
  border-radius: 1px;
  border: 0;
  padding: 2px 5px;
  background-image: linear-gradient(225deg, #f5f5f5, #fafafa);
  white-space: nowrap;
  filter: drop-shadow(-1px 1px 2px #d0d0d099);
}

.archivo_button:hover {
  transform: translateY(-2px);
  filter: drop-shadow(-1px 1px 3px #d0d0d0ff);
}

.archivo_button:active {
  transform: translateY(1px);
}

.is-secondary {
  margin-left: 10px;
}

.simple_button_extra {
  border: 1px solid #c0c0ff;
}

.volverButton {
  margin-top: 20px;
  height: fit-content;
  padding: 3px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 7px;
}

.arrow {
  text-align: bottom;
  height: 22px;
  padding-top: 4px;
}

.pane_container {
  display: flex;
  /* height: 100vh; */
}

.left-pane {
  min-width: 154px;
  max-width: 154px;
  width: 154px;
  box-sizing: border-box;
  padding-top: 45px;
}

.right-pane {
  flex: 1;
  box-sizing: border-box;
}

.side_button {
  width: 100%;
  margin-bottom: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: linear-gradient(225deg, #fafdff, #fafdff);
  color: #4a4a4a;
}

.activeButton {
  background: linear-gradient(225deg, #5a4cd3, #5a4cd3);
  color: #ffffff !important;
}
</style>
